import { Form } from "antd";
import { SourcingRequirementApplicationFormFields } from "../type";

/**
 * 判断是否为生产物料
 */
export function useWatchProductionMaterial() {
  const form = Form.useFormInstance<SourcingRequirementApplicationFormFields>();
  const sourcingType = Form.useWatch("sourcingType", form);

  const isProductionMaterial = sourcingType === "1";

  return {
    isProductionMaterial,
    sourcingType,
  };
}
